export default __webpack_public_path__ + "static/media/detail_small_9_2.f53dd4ef.jpg";